import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DeviceDTO } from '../device/device.model';

@Component({
  standalone: false,
  selector: 'app-device-name',
  templateUrl: './device-name.component.html',
  styleUrls: ['./device-name.component.scss']
})
export class DeviceNameComponent {
  @Input() device: DeviceDTO;
  @Input() currentDeviceBeingEdited: string | null;
  @Output() editDeviceName = new EventEmitter<any>();

  onEditDeviceName(event: MouseEvent | Event) {
    this.editDeviceName.emit(event);
  }

  onStopPropagation(event: MouseEvent) {
    event.stopPropagation();
  }
}